(() => {
  if (!(document.documentElement.lang || '').toLowerCase().startsWith('en')) return;
  const base = ((document.currentScript && document.currentScript.src) || '').replace(/nugina-i18n\.js.*$/, '');
  const load = (n) => new Promise((res) => { const s = document.createElement('script'); s.src = base + 'nugina-dict-' + n + '.js'; s.onload = s.onerror = res; document.head.appendChild(s); });
  Promise.all([1, 2, 3, 4, 5].map(load)).then(() => {
  const D = window.__nuginaDict || {};
  const norm = (s) => s.replace(/\s+/g, ' ').trim();
  const RULES = [
    [/^Från\s+(.+)$/, (m) => 'From ' + m[1]],
    [/^Spara upp till (\d+)\s*% i paket$/i, (m) => 'Save up to ' + m[1] + '% in a bundle'],
    [/^Spara (\d+)\s*kr$/i, (m) => 'Save ' + m[1] + ' SEK'],
    [/^Spara (\d+)\s*%$/i, (m) => 'Save ' + m[1] + '%'],
    [/^(\d+)\s*% i paket$/i, (m) => m[1] + '% in a bundle'],
    [/^(.+) kvar till fri frakt$/i, (m) => m[1] + ' left until free shipping'],
    [/^Du är (.+) från fri frakt$/i, (m) => 'You are ' + m[1] + ' away from free shipping'],
    [/^Lägg i varukorgen · (.+)$/i, (m) => 'Add to cart · ' + m[1]],
    [/^Lägg till (\d+) produkter?(.*)$/i, (m) => 'Add ' + m[1] + ' products' + m[2]],
    [/^Paket: (.+)$/i, (m) => 'Bundle: ' + m[1]],
    [/^träffar för ”(.+)”$/i, (m) => 'results for “' + m[1] + '”'],
    [/^(\d+) träffar$/i, (m) => m[1] + ' results'],
    [/^(\d+) produkter?$/i, (m) => m[1] + (m[1] === '1' ? ' product' : ' products')],
    [/^Betyg (.+) av 5$/i, (m) => 'Rating ' + m[1] + ' out of 5'],
    [/^© (\d{4}) Nugina AB(.*)$/i, (m) => '© ' + m[1] + ' Nugina AB' + m[2]],
  ];
  const tr = (node) => {
    if (node.nodeType === 3) {
      if (node.__tr) return;
      const t = norm(node.nodeValue);
      if (!t) return;
      let out = D[t];
      if (!out) for (const [re, fn] of RULES) { const m = t.match(re); if (m) { out = fn(m); break; } }
      if (out) { node.nodeValue = node.nodeValue.replace(t, out); node.__tr = true; }
    } else if (node.nodeType === 1 && !/^(SCRIPT|STYLE|TEXTAREA|NOSCRIPT)$/.test(node.tagName)) {
      ['aria-label', 'placeholder', 'title', 'alt'].forEach((a) => { const v = node.getAttribute(a); if (v && D[norm(v)]) node.setAttribute(a, D[norm(v)]); });
      if (node.tagName === 'INPUT' && /^(submit|button)$/.test(node.type) && D[norm(node.value)]) node.value = D[norm(node.value)];
      node.childNodes.forEach(tr);
    }
  };
  const run = () => tr(document.body);
  if (document.body) run();
  new MutationObserver((list) => list.forEach((m) => m.addedNodes.forEach(tr))).observe(document.body, { childList: true, subtree: true });
  document.title = D[norm(document.title)] || document.title;
  });
})();
